import GetBrandFromManufacturer from './../../used-vue/api/GetBrandFromManufacturer.js';

export default function (to) {
    let query = to.query || {};

    if (query.manufacturer) {
        if (query.manufacturer !== 'reset') {
            const brandFromManufacturer = GetBrandFromManufacturer(query.manufacturer);
            if (brandFromManufacturer !== 'randd') {
                return {
                    name: 'business.results.brand',
                    params: {
                        brand: brandFromManufacturer,
                    },
                    query: query,
                };
            }
        } else {
            query.manufacturer = '';
        }
    } else if (to.params && to.params.brand) {
        if (to.params.brand !== 'randd') {
            delete query.manufacturer;
            return {
                name: 'business.results.brand',
                params: {
                    brand: to.params.brand,
                },
                query: query,
            };
        }
    }

    return {
        name: 'business.results',
        query: query,
    };
}